import "antd/dist/antd.min.css";
import { useStateValue } from "./Component/StateProviders";
import React from "react";
import "./App.css";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Customer portal
import HomeLayout from "./Component/HomeLayout";
import CustomerLogin from "./portals/customer/CustomerLogin";
import CustomerBooking from "./portals/customer/CustomerBooking";
import CustomerDashboard from "./portals/customer/CustomerDashboard";
import CustomerChangePassword from "./portals/customer/CustomerChangePassword";
import CustomerProfileSettings from "./portals/customer/CustomerProfileSettings";
import ContactUs from "./Component/ContactUs/ContactUs";
import AboutUs from "./Component/AboutUs/AboutUs";
import AppointmentBookingSuccessPopup from "./portals/customer/AppointmentBookingSuccessPopup";
import CustomerDetailsRegister from "./portals/customer/CustomerDetailsRegister";
import NewCustomerRegister from "./portals/customer/NewCustomerRegister";
import CustomerForgotPassword from "./portals/customer/CustomerForgotPassword";
import Invoice from "./Component/Invoice/Invoice";
import CustomerFiles from "./portals/customer/CustomerFiles";
import Deleteaccount from "./Component/Deleteaccount";

import Footer from "./Component/Footer";
import Header from "./Component/Header";

// Admin portal
import AdminLayout from "./portals/admin/AdminLayout";
import AdminScheduleTimings from "./portals/admin/AdminScheduleTimings";
import AdminDashboard from "./portals/admin/AdminDashboard";
import AdminCustomers from "./portals/admin/AdminCustomers";
import AdminCustomerProfile from "./portals/admin/AdminCustomerProfile";
import AdminChangePassword from "./portals/admin/AdminChangePassword";
import AdminMessages from "./portals/admin/AdminMessages";
import AdminAddPrescription from "./portals/admin/AdminAddPrescription";
import AdminNewsletter from "./portals/admin/AdminNewsletter";
import AdminSidebar from "./portals/admin/AdminSidebar";
import AdminAppointmentByDate from "./portals/admin/AdminAppointmentByDate";
import AdminForgotPassword from "./portals/admin/AdminForgotPassword";
import Topbar from "./Component/Topbar";
import Notfound from "./Component/Notfound";
import Termsandconditions from "./Component/Termsandconditions";
import Privacypolicy from "./Component/Privacypolicy";
import Shippingpolicy from "./Component/Shippingpolicy";
import Returnrefund from "./Component/Returnrefund";
import AdminTrash from "./portals/admin/AdminTrash";
import AdminPackages from "./portals/admin/AdminPackages";

import Loader from "./Component/Loader";
import AdminDeleteRequest from "./portals/admin/AdminDeleteRequest";

// window.API_PREFIX = 'https://nonprobative-overvehemently-archer.ngrok-free.dev//'
window.API_PREFIX = "https://api.raive.life/";
window.WEBSOC = "wss://" + String(window.API_PREFIX).split("//")[1];

function MitwankLegacyRedirect() {
  const { pathname } = useLocation();
  const suffix = pathname.replace(/^\/mitwank/, "") || "/";
  const normalized = suffix.startsWith("/") ? suffix : `/${suffix}`;
  const target =
    normalized === "/" ? "/administration" : `/administration${normalized}`;
  return <Navigate to={target} replace />;
}

function App() {
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   setLoading(true)
  //   setTimeout(() => {
  //     setLoading(false)
  //   }, 1000)
  // }, [])

  let navigate = useNavigate();
  const [{ IsRegister, Loading }, dispatch] = useStateValue();

  return (
    <>
      <div>
        {/* {
          Loading ?

            <div className='ns_doc_loader_main_division'>
              <Loader />
            </div>


            :
            ( */}
        <div>
          <Routes path="">
            <Route path="/mitwank/*" element={<MitwankLegacyRedirect />} />
            <Route path="" element={<HomeLayout />}>
              <Route path="login" element={<CustomerLogin />} />
              <Route path="booking" element={<CustomerBooking />} />
              <Route path="medicalrecord" element={<CustomerFiles />} />
              <Route path="dashboard" element={<CustomerDashboard />} />
              <Route
                path="change-password"
                element={<CustomerChangePassword />}
              />
              <Route
                path="profile-setting"
                element={<CustomerProfileSettings />}
              />
              {/* <Route path='reviewdetails' element={<Reviewdetails />} /> */}
              {/* <Route  path='registerdetail' element={<PatientRegister/>} /> */}
              <Route
                path="customer-detail-register"
                element={<CustomerDetailsRegister />}
              />
              <Route path="contact" element={<ContactUs />} />
              <Route path="about" element={<AboutUs />} />
              <Route path="" element={<CustomerLogin />} />
              <Route
                path="bookingsuccessfully"
                element={<AppointmentBookingSuccessPopup />}
              />
            </Route>

            <Route path="loader" element={<Loader />} />

            <Route
              path="/forget-password"
              element={
                <>
                  <Header />
                  <CustomerForgotPassword />
                  <Footer />
                </>
              }
            />
            <Route
              path="/customer-detail-register"
              element={
                <>
                  <Header />
                  {!IsRegister ? <CustomerDetailsRegister /> : null}
                  <Footer />
                </>
              }
            />
            <Route
              path="/register"
              element={
                <>
                  <Header />
                  <NewCustomerRegister />
                  <Footer />
                </>
              }
            />
            <Route path="invoice" element={<Invoice />} />

            <Route path="/administration" element={<AdminLayout />}>
              <Route
                path="schedule-timing"
                element={<AdminScheduleTimings />}
              />
              <Route path="packages" element={<AdminPackages />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="trash" element={<AdminTrash />} />
              <Route path="my-clients" element={<AdminCustomers />} />
              <Route
                path="clientprofile/:PID"
                element={<AdminCustomerProfile />}
              />
              <Route
                path="mitwankchangepassword"
                element={<AdminChangePassword />}
              />
              <Route path="clientmessages" element={<AdminMessages />} />
              <Route
                path="addprescription"
                element={<AdminAddPrescription />}
              />
              <Route path="newsletter" element={<AdminNewsletter />} />
              <Route path="doctorsidebar" element={<AdminSidebar />} />
              <Route
                path="mitwankappointmentbydate"
                element={<AdminAppointmentByDate />}
              />
              <Route path="delete-request" element={<AdminDeleteRequest />} />
              {/* <Route path='loader' element={<Loader/>}/> */}
            </Route>

            <Route
              path="/adminforgetpassword"
              element={
                <>
                  <Topbar />
                  <Header />
                  <AdminForgotPassword />
                  <Footer />
                </>
              }
            />
            <Route path="/*" element={<Notfound />} />
            <Route
              path="terms-and-conditions"
              element={
                <>
                  <Header />
                  <Termsandconditions />
                  <Footer />
                </>
              }
            />
            <Route
              path="privacy"
              element={
                <>
                  <Header />
                  <Privacypolicy />
                  <Footer />
                </>
              }
            />
            <Route
              path="return-and-refund-policy"
              element={
                <>
                  <Header />
                  <Returnrefund />
                  <Footer />
                </>
              }
            />
            <Route
              path="shipping-policy"
              element={
                <>
                  <Header />
                  <Shippingpolicy />
                  <Footer />
                </>
              }
            />

            <Route path="delete-account" element={<Deleteaccount />} />
          </Routes>
        </div>
        {/* )
        } */}
      </div>

      {/* <Routes path="">
        <Route path="" element={<HomeLayout />} >
          <Route path="login" element={<DoccureLogin />} />

          <Route path="booking" element={<Patient_Booking />} />
          <Route path="dashboard" element={<PatientDashboard />} />
          <Route path="changepassword" element={<PatientChangePassword />} />

          <Route path='profilesetting' element={<PatientProfilesettings />} />
          <Route path='ordersummary' element={<OrderSummary />} />


          <Route path='patientregister' element={<PatientRegister />} />

          <Route path='contactUs' element={<ContactUs />} />
          <Route path='aboutus' element={<AboutUs />} />

          <Route path='' element={<Homepage />} />

          <Route path='bookingsuccessfully' element={<Appointmentbookingsuccessfullypopup />} />

        </Route>


        <Route path="/forgetpassword" element={<><Header /><DoccureForgotPassword /><Footer /></>} />
        <Route path="/client-detail-register" element={<><Header />{!IsRegister ? <PatientRegister /> : null}<Footer /></>} />
        <Route path="/register" element={<><Header /><DoccureRegister /><Footer /></>} />

        <Route path="/coach" element={<Adminlayout />} >


          <Route path="schedule-timing" element={<Schedule_Timing />} />
          <Route path="dashboard" element={<Doctor_Dashboard />} />
          <Route path="mypatient" element={<DoctorMyPatient />} />
          <Route path="patientprofile/:PID" element={<DoctorPatientProfile />} />
          <Route path="mitwankchangepassword" element={<mitwankchangepassword />} />

          <Route path="addprescription" element={<AddPrescription />} />
          <Route path="doctorsidebar" element={<DoctorSidebar />} />
          <Route path="mitwankappointmentbydate" element={<mitwankappointmentbydate />} />


        </Route>


      </Routes> */}

      <Toaster />
    </>
  );
}

export default App;
